import type { Participant } from "livekit-client";

export function parseParticipantAvatarFromMetadata(metadata: string | undefined): string | null {
  if (!metadata) return null;
  try {
    const parsed = JSON.parse(metadata) as { avatarUrl?: unknown };
    if (typeof parsed.avatarUrl === "string" && parsed.avatarUrl.trim()) {
      return parsed.avatarUrl.trim();
    }
  } catch {
    /* ignore malformed metadata */
  }
  return null;
}

export function resolveParticipantAvatarUrl(
  participant: Pick<Participant, "identity" | "metadata">,
  avatarByIdentity: ReadonlyMap<string, string> | undefined,
  localAvatarUrl: string | null | undefined,
  isLocal: boolean
): string | null {
  if (isLocal && localAvatarUrl) return localAvatarUrl;
  const fromMap = avatarByIdentity?.get(participant.identity);
  if (fromMap) return fromMap;
  return parseParticipantAvatarFromMetadata(participant.metadata);
}
